declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const configurationtanentsRoute: Router = {
    path: '/configurationtanents',
    name: 'setting',
    meta: {
        title: '配置租户管理'
    },
    component: main,
    children: [
        { path: 'tanents', meta: { title: '配置租户详情' }, name: 'tanents', component: () => import('../views/shopee/configurationsetting/configurationtenant.vue') },
    ]
};
export const appRouters: Array<Router> = [{
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      //  { path: 'role', permission: 'Pages.Roles', meta: { title: 'Roles' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
    //    { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') }
        { path: 'tenant', permission: 'Pages.Tenants', meta: { title: '租户管理' }, name: 'basesetting', component: () => import('../views/shopee/basesetting/basesetting.vue') },
        { path: 'channel', permission: 'Pages.Tenants', meta: { title: '渠道管理' }, name: 'channel', component: () => import('../views/shopee/channel/channelmaintain-list.vue') },
        { path: 'orderstatistics', permission: 'Pages.Tenants', meta: { title: '订单统计' }, name: 'orderstatistics', component: () => import('../views/shopee/order/order-statistics.vue') },
        { path: 'erporderstatistics', permission: 'Pages.Tenants', meta: { title: 'ERP订单统计' }, name: 'erporderstatistics', component: () => import('../views/shopee/order/order-allstatistics.vue') },
       /* { path: 'pddpromote', permission: 'Pages.Tenants', meta: { title: '拼多多推广备案' }, name: 'pddpromote', component: () => import('../views/setting/pdd/pddpromote-list.vue') },*/
        //{ path: 'orderstatistics', permission: 'Pages.Tenants', meta: { title: '订单统计' }, name: 'orderstatistics', component: () => import('../views/shopee/order/order-statistics.vue') },
        { path: 'config', permission: 'Pages.Tenants', meta: { title: '配置管理' }, name: 'config', component: () => import('../views/shopee/configurationsetting/configurationsetting.vue') },
        { path: 'seeconfig', permission: 'Pages.Tenants', meta: { title: '查看产品配置' }, name: 'seeconfig', component: () => import('../views/shopee/seeproductconfiguration/seeproductconfiguration.vue') },
        { path: 'pddtoken', permission: 'Pages.Tenants', meta: { title: 'PDDToken管理' }, name: 'pddtoken', component: () => import('../views/shopee/pddtokenmanagement/pddtokenmanagement.vue') },
    
    ]
}]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters,
    configurationtanentsRoute
];
